/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import { useParams, useHistory } from "react-router-dom";
import { Select, Button, Input, UploadList } from "components/core";
import { PageWrapper } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { fetchBackend, uploadFile, uuidv4, formatSchemaCar } from "helpers";
import { optionsTypeVehicle, optionsYears, CarSchema } from "constants/index";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { message } from "antd";

// const normalizeDataSelect = e => e.map(({name}) => ({id: name, title:}))
// brands.findIndex(el => )

const SchemaMailbox = yup.object().shape({
  type: yup.string().required("Seleccione el tipo de vehículo"),
  brand: yup.string().required("Seleccione una marca"),
  model: yup.string().required("Seleccione el modelo"),
  year: yup.string().required("Seleccione el año"),
  serial: yup.string().required("Ingresa el número de serie"),
  plates: yup.string().required("Ingresa las placas"),
  color: yup.string().required("Ingresa el color"),
});

const AddAndUpdateVehicle = ({ setLoading }) => {
  const [isChargin, setCharge] = useState(false);
  const [isStartPage, setStartPage] = useState(false);
  const [isLoadingModels, setLoadingModels] = useState(false);
  const [isLoadingBrands, setLoadingBrands] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [state, setState] = useState(CarSchema);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const gContext = useGlobalContext();
  const { id: currentVehicle } = useParams();
  const history = useHistory();

  const {
    handleSubmit,
    register,
    control,
    errors,
    getValues,
    setError,
    setValue,
  } = useForm({
    resolver: yupResolver(SchemaMailbox),
  });

  const handleOnRemovePicture = useCallback(({ name }) => {
    const { pictures } = getValues();
    const data = pictures.filter((el) => el.name !== name);
    setValue("pictures", data); // ✅ performant
  }, []);

  const getBrands = useCallback(
    async ({ type }) => {
      setLoadingBrands(true);
      const { error, response } = await fetchBackend({ url: `brand/${type}` });
      setLoadingBrands(false);
      // console.log(response);
      if (!error) {
        setBrands(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener las marcas, revisa tu conexión a internet",
          type: "error",
        });
      }
    },
    [gContext]
  );

  const getModels = useCallback(
    async ({ brand, type }) => {
      setLoadingModels(true);

      const { error, response } = await fetchBackend({
        url: `template/${brand}/${type}`,
      });

      setLoadingModels(false);

      console.log(brand);
      console.log(type);

      console.log(response);
      if (!error) {
        setModels(response);

        if (!response.length) {
          gContext.toggleAlert({
            message:
              "No hay modelo disponibles para mostrar con este tipo de vehiculo y marca.",
            type: "warning",
          });
        }
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener los modelos, revisa tu conexión a internet",
          type: "error",
        });
      }
    },
    [gContext]
  );

  const updateListBrands = useCallback(async () => {
    const { type } = getValues();

    if (type) {
      await getBrands({ type: type.toUpperCase() });
    } else {
      setError("type", {
        type: "required",
        message: "Selecciona un tipo valido",
      });
    }
  }, []);

  const updateListModelVehicles = useCallback(async () => {
    const { brand, type } = getValues();

    if (brand && type) {
      await getModels({ brand, type });
    } else if (!brand) {
      setError("brand", {
        type: "required",
        message: "Selecciona una marca valida",
      });
    } else {
      setError("type", {
        type: "required",
        message: "Selecciona un tipo valido",
      });
    }
  }, []);

  // aksjfasbfba
  const uploadPicture = async (item) => {
    const user = gContext.currentUser;
    return new Promise((res, rej) => {
      uploadFile(
        item,
        `cars/${user._id}${user.name}/${uuidv4()}`,
        (url) => res(url),
        (percetage) => percetage === 100 && console.log("file upload"),
        (errorsStorage) => rej(errorsStorage)
      );
    });
  };

  const uploadPictures = async (file) => {
    const promises = file.map((item) => {
      return new Promise((res, rej) => uploadPicture(item).then(res, rej));
    });

    const pictures = await Promise.all(promises);
    return pictures;
  };

  const updateCar = async (newObj) => {
    const { error } = await fetchBackend({
      method: "put",
      url: `car/${state._id}`,
      data: newObj,
    });

    if (!error) {
      setCharge(false);
      setTimeout(() => history.push("/vehiculos"), 250);
    } else {
      setCharge(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar actualizar el vehículo, revisa la información",
        type: "error",
      });
    }
  };

  const addCar = async (obj) => {
    const { error } = await fetchBackend({
      method: "post",
      url: "car",
      data: obj,
    });

    if (!error) {
      setCharge(false);
      setTimeout(() => history.push("/vehiculos"), 250);
    } else {
      setCharge(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar registrar el vehículo, revisa la información",
        type: "error",
      });
    }
  };

  const handleUploadData = async (obj, file = []) => {
    if (isUpdate) {
      setCharge(true);
      if (!file.length) {
        await updateCar(obj);
      } else {
        const newPictures = await uploadPictures(file);
        const pictures = obj.pictures.concat(newPictures);
        const newObj = { ...obj, pictures };
        await updateCar(newObj);
      }
    } else {
      if (file.lenght > 0) {
        setCharge(true);
        // if (!file.length) {
        //   await addCar(obj);
        // } else {
        const pictures = await uploadPictures(file);
        const newObj = { ...obj, pictures };
        await addCar(newObj);
        // }
      } else {
        gContext.toggleAlert({
          message: "Se necesita cargar mínimo 1 foto del vehículo",
          type: "error",
        });
      }
    }
  };

  const onSubmit = async (form, e) => {
    const user = gContext.currentUser?._id || "";
    const { model, year, serial, plates, color, pictures, brand, type } = form;

    const labelBrand = brands.find((el) => el._id === brand)?.brand || "";
    const labelModel = models.find((el) => el._id === model)?.name || "";

    const obj = {
      type,
      user,
      model,
      brand,
      year,
      serial,
      plates,
      color,
      nickName: `${labelBrand} ${labelModel}`,
      pictures: state.pictures || [],
    };

    await handleUploadData(obj, pictures);
    // e.target.reset();
  };

  const getSingleCar = useCallback(async (idVehicle) => {
    const { error, response } = await fetchBackend({ url: `car/${idVehicle}` });
    if (!error) {
      return response;
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener los datos del vehiculo, revisa tu conexión a internet",
        type: "error",
      });
      return [];
    }
  }, []);

  const getInitialState = useCallback(async () => {
    if (!currentVehicle) {
      setState(CarSchema);
      setIsUpdate(false);
    } else {
      const singleCar = await getSingleCar(currentVehicle);
      const data = formatSchemaCar(singleCar[0]);
      setState(data);
      setIsUpdate(true);

      const type = (data?.type || "").toUpperCase();

      if (type && data?.brand) {
        await getBrands({ type });
        await getModels({ type, brand: data?.brand });
      }
    }

    setLoading(false);
    setStartPage(true);
  }, [currentVehicle]);

  useEffect(() => {
    getInitialState();
  }, [getInitialState]);

  if (!isStartPage) return null;

  return (
    <PageWrapper
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Agregar un nuevo vehículo</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)} className="w-100">
        <Row className="pb4">
          <Select
            xs={12}
            md={12}
            name="type"
            defaultValue={state?.type}
            valueOption="id"
            labelOption="title"
            placeholder="Elige un tipo"
            label="Tipo"
            ref={register}
            disabled={isChargin}
            options={optionsTypeVehicle}
            error={errors.type?.message}
          />
          <Select
            xs={12}
            md={12}
            name="brand"
            defaultValue={state?.brand}
            valueOption="_id"
            labelOption="brand"
            placeholder="Marca"
            label={`Marca ${isLoadingBrands ? "Cargando las marcas" : ""}`}
            ref={register}
            disabled={isChargin}
            onClick={updateListBrands}
            options={brands}
            error={errors.brand?.message}
          />
          <Select
            xs={12}
            md={12}
            name="model"
            defaultValue={state?.model}
            label={`Modelo ${isLoadingModels ? "Cargando modelos" : ""}`}
            valueOption="_id"
            labelOption="name"
            placeholder="Da click para cargar los modelos disponibles"
            ref={register}
            onClick={updateListModelVehicles}
            disabled={isChargin}
            options={models}
            error={errors.model?.message}
          />
          <Select
            md={12}
            name="year"
            defaultValue={state?.year || new Date().getFullYear()}
            label="Año"
            valueOption="id"
            labelOption="title"
            placeholder="Año"
            ref={register}
            disabled={isChargin}
            options={optionsYears}
            error={errors.year?.message}
          />
          <Input
            name="serial"
            defaultValue={state?.serial}
            placeholder="Número de serie"
            ref={register}
            disabled={isChargin}
            error={errors.serial?.message}
          />
          <Input
            name="plates"
            defaultValue={state?.plates}
            placeholder="Placas"
            ref={register}
            disabled={isChargin}
            error={errors.plates?.message}
          />
          <Input
            name="color"
            defaultValue={state?.color}
            placeholder="Color"
            ref={register}
            disabled={isChargin}
            error={errors.color?.message}
          />
          <Controller
            name="pictures"
            control={control}
            render={(props) => (
              <UploadList
                onChange={(file) => props.onChange(file)}
                defaultValue={state.pictures || []}
                value={props.value}
                text="Agregar fotos"
                onRemove={handleOnRemovePicture}
              />
            )} // props contains: onChange, onBlur and value
          />

          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              loading={isChargin}
            >
              Agregar
            </Button>
          </Col>
        </Row>
      </form>
    </PageWrapper>
  );
};

export default withLoader(AddAndUpdateVehicle, "Cargando formulario");
